/**
 * @description: 导购员工业绩汇总报表
 * @author: hwx
*/
<template>
    <div class="dyh-report">
        <div class="dyh-list">
            <el-form :inline="true" size="small" :model="dyh_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="dyh_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="dyh_list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="dyh_list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="dyh_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="getGuide($event, 'dyh')">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-input v-model="dyh_gtype_names" class="el-ellipsis" clearable placeholder="请选择商品类型" @focus="dyhGtypeSelect" @clear="dyhGtypeDel"></el-input>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="dyh_list_form.goods_name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="导购员工">
                    <el-select v-model="dyh_list_form.shopping_guide" filterable clearable placeholder="请选择导购员工">
                        <el-option v-for="item in guide_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="dyhQuery">查询</el-button>
                    <el-button @click="dyhExportSet">导出</el-button>
                    <el-button class="dyh-type el-button--primary" @click="dyhSortBy('goods')">按商品统计</el-button>
                    <el-button class="dyh-type" @click="dyhSortBy('staff')">按员工统计</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="dyh_list"
                v-show="dyh_sortby == 'goods'">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column width="130" label="门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column width="130" label="商品名称">
                    <template slot-scope="scope">
                        {{(scope.row.goods_name&&scope.row.goods_name.length > '14') ? scope.row.goods_name.slice(0, 14) + '...' : scope.row.goods_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="actual_pay" label="折后单价"></el-table-column>
                <el-table-column prop="quantity" label="销售数量"></el-table-column>
                <el-table-column prop="actual_pay_total" label="折后总额"></el-table-column>
                <el-table-column prop="deduct_rate" label="商品提成百分比"></el-table-column>
                <el-table-column prop="deduct_amount" label="商品提成金额"></el-table-column>
                <el-table-column prop="shopping_guide_name" label="导购员工"></el-table-column>
                <el-table-column prop="deduct_amount_total" label="提成总额"></el-table-column>
            </el-table>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="dyh_list"
                v-show="dyh_sortby == 'staff'">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column label="门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="shopping_guide_name" label="导购员工"></el-table-column>
                <el-table-column prop="deduct_amount_total" label="提成总额"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-4">销售数量:</label>
                    <div class="list-total">{{dyh_quantity_total}}</div>
                    <label class="list-label-4">提成总额:</label>
                    <div class="list-total">{{dyh_deduct_amount_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="dyh_list_page"
                    :total="dyh_list_total"
                    @current-change="getDyhList">
                </el-pagination>
            </div>
            <!-- 商品类型弹窗 -->
            <div class="export-wrap" ref="dyh_gtype_alert">
                <el-checkbox :indeterminate="dyh_gtype_sign" v-model="dyh_gtype_all" @change="dyhGtypeAll">全选</el-checkbox>
                <el-checkbox-group v-model="dyh_gtype_ids" @change="dyhGtypeChange">
                    <el-checkbox v-for="item in goods_type_list" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="dyh_list_export">
                <div v-show="dyh_sortby == 'goods'">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <el-checkbox :indeterminate="dyh_export_sign" v-model="dyh_export_all" @change="dyhExportAll">全选</el-checkbox>
                    <el-checkbox-group v-model="dyh_export_ids" @change="dyhExportChange">
                        <el-checkbox label="shop_name">门店</el-checkbox>
                        <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                        <el-checkbox label="goods_name">商品名称</el-checkbox>
                        <el-checkbox label="goods_unit_name">单位</el-checkbox>
                        <el-checkbox label="actual_pay">折后单价</el-checkbox>
                        <el-checkbox label="quantity">销售数量</el-checkbox>
                        <el-checkbox label="actual_pay_total">折后总额</el-checkbox>
                        <el-checkbox label="deduct_rate">商品提成百分比</el-checkbox>
                        <el-checkbox label="deduct_amount">商品提成金额</el-checkbox>
                        <el-checkbox label="shopping_guide_name">导购员工</el-checkbox>
                        <el-checkbox label="deduct_amount_total">提成总额</el-checkbox>
                    </el-checkbox-group>
                    <h3>请选择导出报表的文件格式</h3>
                    <el-radio v-model="dyh_export_type" label="1">excel表格</el-radio>
                    <el-radio v-model="dyh_export_type" label="2">pdf文件</el-radio>
                </div>
                <div v-show="dyh_sortby == 'staff'">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <el-checkbox :indeterminate="dyh_export_sign" v-model="dyh_export_all" @change="dyhExportAll">全选</el-checkbox>
                    <el-checkbox-group v-model="dyh_export_ids" @change="dyhExportChange">
                        <el-checkbox label="shop_name">门店</el-checkbox>
                        <el-checkbox label="shopping_guide_name">导购员工</el-checkbox>
                        <el-checkbox label="deduct_amount_total">提成总额</el-checkbox>
                    </el-checkbox-group>
                    <h3>请选择导出报表的文件格式</h3>
                    <el-radio v-model="dyh_export_type" label="1">excel表格</el-radio>
                    <el-radio v-model="dyh_export_type" label="2">pdf文件</el-radio>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                guide_list: [],
                goods_type_list: [],

                dyh_list_form: {
                    start_date: moment().subtract(1, 'day').format('YYYY-MM-DD 08:00'),
                    end_date: moment().format('YYYY-MM-DD 08:00'),
                    shop_id: '',
                    goods_name: '',
                    shopping_guide: ''
                },
                dyh_gtype_sign: false,
				dyh_gtype_all: false,
                dyh_gtype_ids: [],
                dyh_gtype_names: '',
				dyh_list: [],
				dyh_list_page: 1,
                dyh_list_total: 0,
                dyh_export_sign: false,
				dyh_export_all: false,
                dyh_export_ids: [],
                dyh_export_list1: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'actual_pay', 'quantity', 'actual_pay_total', 'deduct_rate', 'deduct_amount', 'shopping_guide_name', 'deduct_amount_total'],
                dyh_export_list2: ['shop_name', 'shopping_guide_name', 'deduct_amount_total'],
                dyh_export_type: '1',
                dyh_sortby: 'goods',
                dyh_quantity_total: '',
                dyh_deduct_amount_total: '',
            }
        },
        mounted: function() {
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.dyh_list_form.shop_id = this.shop_list[0].id;
                this.getGoodsType();
                this.getGuide(this.shop_list[0].id);
                this.getDyhList(1);
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.dyh_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').toDate(),
                    endDate: moment().toDate(),
                    maxDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.dyh_list_form.start_date = start.format('YYYY-MM-DD 08:00');
                    _this.dyh_list_form.end_date = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 获取门店
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getAllGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取导购员工
            getGuide: function(shop_id) {
                const _this = this;

                _this.dyh_list_form.shopping_guide = '';
                Vue.axios.post('user/getSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.guide_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            // 商品类型
            dyhGtypeSelect() {
                const _this = this;
                const c_dyh_gtype_ids = _this.dyh_gtype_ids,
                    c_dyh_gtype_sign = _this.dyh_gtype_sign,
                    c_dyh_gtype_all = _this.dyh_gtype_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品类型', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.dyh_gtype_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.dyh_gtype_ids = c_dyh_gtype_ids;
                        _this.dyh_gtype_sign = c_dyh_gtype_sign;
                        _this.dyh_gtype_all = c_dyh_gtype_all;
                    }
                }, function() {
                    let arr = [];
                    _this.goods_type_list.forEach(item => {
                        _this.dyh_gtype_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.dyh_gtype_names = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.dyh_gtype_ids = c_dyh_gtype_ids;
                    _this.dyh_gtype_sign = c_dyh_gtype_sign;
                    _this.dyh_gtype_all = c_dyh_gtype_all;
                });
            },
            dyhGtypeDel() {
				this.dyh_gtype_sign = false;
                this.dyh_gtype_all = false;
				this.dyh_gtype_ids = [];
            },
            dyhGtypeAll(val) {
                let ids = [];
				this.goods_type_list.forEach(v => {
					ids.push(v.id);
				});
				this.dyh_gtype_ids = val ? ids : [];
				this.dyh_gtype_sign = false;
			},
			dyhGtypeChange(val) {
				const len = val.length;
				this.dyh_gtype_sign = len > 0 && len < this.goods_type_list.length;
				this.dyh_gtype_all = len === this.goods_type_list.length;
            },
            // 列表
            getDyhList(page) {
				const _this = this;

                _this.loading = true;
                _this.dyh_list_page = page
                let url = "FinanceReport2/shoppingGuideOrderCount";
                let data = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.dyh_list_form.start_date,
                            "end_date": _this.dyh_list_form.end_date,
                            "shop_id": _this.dyh_list_form.shop_id,
                            "goods_type": _this.dyh_gtype_ids,
                            "goods_name": _this.dyh_list_form.goods_name,
                            "shopping_guide": _this.dyh_list_form.shopping_guide
                        }
                    },
                    "comment": ""
                };
                if(_this.dyh_sortby == 'staff') {
                    url = "FinanceReport2/shoppingGuideOrderCountByUser";
                }
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.dyh_list_total = Number(res.data.response.result.count);
							_this.dyh_quantity_total = res.data.response.result.quantity_total;
                            _this.dyh_deduct_amount_total = res.data.response.result.deduct_amount_total;
						}
						_this.dyh_list = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			dyhQuery() {
                this.dyh_list = [];
                this.dyh_list_page = 1,
                this.dyh_list_total = 0,
				this.getDyhList(this.dyh_list_page);
            },
            // 统计方式
            dyhSortBy: function(type) {
                const _this = this;

                _this.dyh_sortby = type;
                $('.dyh-type').removeClass('el-button--primary');
                if(type == 'goods') {
                    $('.dyh-type').eq(0).addClass('el-button--primary');
                } else if(type == 'staff') {
                    $('.dyh-type').eq(1).addClass('el-button--primary');
                }
                _this.getDyhList(1);
            },
            // 导出
            dyhExportAll(val) {
                if(this.dyh_sortby == 'goods') {
                    this.dyh_export_ids = val ? this.dyh_export_list1 : [];
                } else if(this.dyh_sortby == 'staff') {
                    this.dyh_export_ids = val ? this.dyh_export_list2 : [];
                }
				this.dyh_export_sign = false;
			},
			dyhExportChange(val) {
				const len = val.length;
                if(this.dyh_sortby == 'goods') {
                    this.dyh_export_all = len === this.dyh_export_list1.length;
                    this.dyh_export_sign = len > 0 && len < this.dyh_export_list1.length;
                } else if(this.dyh_sortby == 'staff') {
                    this.dyh_export_all = len === this.dyh_export_list2.length;
                    this.dyh_export_sign = len > 0 && len < this.dyh_export_list2.length;
                }
			},
            dyhExportSet: function() {
                const _this = this;

                let report_type = 'FinanceReport2/shoppingGuideOrderCountExport'
                if(this.dyh_sortby == 'staff') {
                    report_type = 'FinanceReport2/shoppingGuideOrderCountByUserExport'
                }
                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": report_type
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.dyh_export_ids = res.data.response.result.export_fields;
                            _this.dyh_export_type = res.data.response.result.export_type;
                        } else {
                            if(_this.dyh_sortby == 'goods') {
                                _this.dyh_export_ids = _this.dyh_export_list1;
                            } else if(_this.dyh_sortby == 'staff') {
                                _this.dyh_export_ids = _this.dyh_export_list2;
                            }
                            _this.dyh_export_type = '1';
                        }
                        _this.dyhExportChange(_this.dyh_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.dyh_list_export)
                }, function() {
                    _this.dyhExport();
                });
            },
            dyhExport: function() {
                if(this.dyh_sortby == 'goods') {
                    window.location.href = Vue.ctUrl + "FinanceReport2/shoppingGuideOrderCountExport?" +
                        "&start_date=" + this.dyh_list_form.start_date +
                        "&end_date=" + this.dyh_list_form.end_date +
                        "&shop_id=" + this.dyh_list_form.shop_id +
                        "&goods_type=" + this.dyh_gtype_ids +
                        "&goods_name=" + this.dyh_list_form.goods_name +
                        "&shopping_guide=" + this.dyh_list_form.shopping_guide +
                        "&export_fields=" + JSON.stringify(this.dyh_export_ids) +
                        "&export_type=" + this.dyh_export_type;
                } else if(this.dyh_sortby == 'staff') {
                    window.location.href = Vue.ctUrl + "FinanceReport2/shoppingGuideOrderCountByUserExport?" +
                        "&start_date=" + this.dyh_list_form.start_date +
                        "&end_date=" + this.dyh_list_form.end_date +
                        "&shop_id=" + this.dyh_list_form.shop_id +
                        "&goods_type=" + this.dyh_gtype_ids +
                        "&goods_name=" + this.dyh_list_form.goods_name +
                        "&shopping_guide=" + this.dyh_list_form.shopping_guide +
                        "&export_fields=" + JSON.stringify(this.dyh_export_ids) +
                        "&export_type=" + this.dyh_export_type;
                }
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .export-wrap {
        .el-checkbox {
            width: 100px;
        }
    }
</style>